import { useState } from "react";
import { Text } from "../../../../../components/common/typography";
import { usePasswordLogin } from "../../../hooks/usePasswordLogin";
import { DEMO_ACCOUNTS } from "../../../../../mocks/data/user";
import { IconUser, IconBuildingStore } from "@tabler/icons-react";

const ICONS = [IconUser, IconBuildingStore] as const;

export function DemoAccountPicker() {
  const isMockMode = import.meta.env.VITE_USE_MOCKS === "true";
  const { login } = usePasswordLogin();
  const [loading, setLoading] = useState<string | null>(null);

  if (!isMockMode) return null;

  const handleDemoLogin = async (email: string, password: string) => {
    setLoading(email);
    try {
      await login(email, password);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="mt-6 flex w-full flex-col gap-3 border-t border-borderLight pt-6">
      <Text variant="bodySmMedium" tone="muted">
        Demo accounts (mock mode)
      </Text>
      <div className="flex flex-col gap-3 sm:flex-row">
        {DEMO_ACCOUNTS.map((account, i) => {
          const Icon = ICONS[i];
          return (
            <button
              key={account.email}
              type="button"
              disabled={loading !== null}
              onClick={() => handleDemoLogin(account.email, account.password)}
              className="flex flex-1 items-center gap-3 rounded-xl border border-borderDefault bg-bgWhite px-4 py-3 text-left transition-colors hover:bg-bgLight disabled:opacity-50"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-bgLight">
                <Icon size={20} className="text-textBody" />
              </div>
              <div className="flex flex-col">
                <Text variant="bodySmBold" tone="dark">
                  {account.label}
                </Text>
                <Text variant="bodyXs" tone="muted">
                  {account.description}
                </Text>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
